import { Box } from '@chakra-ui/react'

import type { DirectionType } from '../aiNodeMenu'

import FormulaSuggestion from './formulaSuggestion'

import type { DomainNode } from '@app/types'

interface FormulaSuggestionsProps {
  suggestions: string[]
  node: DomainNode
  direction: DirectionType
  handle: 'top' | 'bottom' | 'left' | 'right'
  additionalInstructions?: string
  onSuccess?: () => void
  setLoading: (loading: boolean) => void
  loading: boolean
}

const FormulaSuggestions = ({
  suggestions,
  node,
  direction,
  handle,
  additionalInstructions,
  onSuccess,
  setLoading,
  loading
}: FormulaSuggestionsProps) => {
  if (suggestions.length === 0) {
    return null
  }

  return (
    <Box mt={4}>
      {suggestions.map((formula) => (
        <FormulaSuggestion
          key={formula}
          formula={formula}
          node={node}
          direction={direction}
          handle={handle}
          additionalInstructions={additionalInstructions}
          onSuccess={onSuccess}
          setLoading={setLoading}
          loading={loading}
        />
      ))}
    </Box>
  )
}

export default FormulaSuggestions
